export default __webpack_public_path__ + "static/media/cloud.517e1861.svg";